export default "__VITE_PUBLIC_ASSET__23c8c64a__"